<ng-template #alertSnackBar>
  <div>
    <h2>{{ title }}</h2>
    <div class="mat-subtitle-2" *ngFor="let line of message">{{ line }}</div>
  </div>
</ng-template>
